/* ==========================================================================
   UiPanel > Client
   ========================================================================== */

const { elementExist } = require('@bluekiri/alexandria/helpers/domHelpers');
const { randomId } = require('@bluekiri/alexandria/helpers/dataHelpers');
const uipanelPrototype = require('./prototype');
const baseConfig = require('./config');

/* Utilities functions */
const panelInStore = instance => instance.getStore().filter(item => item.type === instance.type);
const panelIsUnique = instance => panelInStore(instance).length > 0;
const getTriggers = instance => instance.config.triggers;

/**
 * UiPanel component
 * @param {selector} String selector for the component in the client side.
 */
module.exports = function UiPanel(selector = '[data-component="UiPanel"]', configuration = {}) {
    if (elementExist(selector)) {
        // Build instance based on customm input object so we inherit the proto methods
        const instance = Object.create(uipanelPrototype);

        // Config
        instance.config = { ...baseConfig, ...configuration };

        // Element reference
        instance.element = document.querySelector(selector);

        // Id reference
        instance.id = instance.element.dataset.id || randomId('uipanel');

        /* Type reference control */
        instance.type = configuration.type;

        if (panelIsUnique(instance)) return checkUniquePanel(instance);

        // Auto init
        if (instance.config.init) instance.init();

        return instance;
    }
};

function checkUniquePanel(instance) {
    /* Get referene to the trigger for this modal to apply to the store one */
    const triggers = getTriggers(instance);

    /* Remove from dom newly created modal to replace it */
    instance.removeFromDom();

    /* Replace instance with the current in store */
    const newInstance = panelInStore(instance)[0];

    newInstance.config.triggers.push(...triggers);

    /* Init new triggrs */
    newInstance.addTriggers(triggers);

    return newInstance;
}
